import VideoIcon from './VideoIcon';

export default VideoIcon;
